import React, {Fragment} from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import ImageEmployee from './ImageEmployee.jsx'
//import EventEmitter from 'react-native-md5'
import md5 from 'react-native-md5'
import 'bootstrap/dist/css/bootstrap.min.css'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import _ from 'lodash'

library.add(faSearch)

const tableStyle = {
  backgroundColor: '#ffffff',
}

const headerStyle = {
  color: 'black',
}

const divStyle = {
  paddingTop: '30px',
}

const linkStyle = {
  fontWeight: 'normal',
  color: 'black',
  paddingRight: '10px',
  border: 'none',
}

const aStyle = {
  display: 'none',
}

class Table extends React.Component {
  constructor(props) {
    super(props)
    if (_.size(props.employees) > 0) {
      this.state = {
        emp: props.employees,
        nameSorting: 'ASC',
        teamsSorting: 'DESC',
        emailSorting: 'DESC',
        telephoneSorting: 'DESC',
        workingHoursSorting: 'DESC',
        hiringDateSorting: 'DESC',
        columnSorting: 'name',
      }
    }
  }

  // search(force) {
  search() {
    let existingString = $('.mysearche').val()
    /*if (!force && existingString.length < 3) return; //wasn't enter, not > 2 char
    $.get('/Tracker/Search/' + existingString, function(data) {
        $('div#results').html(data);
        $('#results').show();
    });*/
    if (existingString.length === 0) {
      existingString = 'all_employees'
    }
    fetch('/api/v1/search_emp/' + this.state.emp.req_id + '/' + existingString, {
      method: 'GET',
      dataType: 'JSON',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    })
    .then((resp) => {
      return resp.json()
    })
    .then((data) => {
      this.setState({ emp: data })
    })
    .catch((error) => {
      console.error(error, 'catch the hoop')
    })
  }

  renderHeader(type) {
    if (type === 'admin'){
      return <Fragment><th key="picture"></th><th key="name"><a href={'#'} style={headerStyle} onClick={() => this.handleHeaderClick('name')}>Name</a></th><th key="teams"><a href={'#'} style={headerStyle} onClick={() => this.handleHeaderClick('teams')}>Teams</a></th><th key="email"><a href={'#'} style={headerStyle} onClick={() => this.handleHeaderClick('email')}>Email</a></th><th key="telephone"><a href={'#'} style={headerStyle} onClick={() => this.handleHeaderClick('telephone')}>Telephone</a></th><th key="workingh"><a href={'#'} style={headerStyle} onClick={() => this.handleHeaderClick('workingHours')}>Working hours</a></th><th key="employedSince"><a href={'#'} style={headerStyle} onClick={() => this.handleHeaderClick('hiringDate')}>Employed since</a></th><th key="actions" colSpan="2">Actions</th></Fragment>
    }
    return <Fragment><th key="picture"></th><th key="name"><a href={'#'} style={headerStyle} onClick={() => this.handleHeaderClick('name')}>Name</a></th><th key="teams"><a href={'#'} style={headerStyle} onClick={() => this.handleHeaderClick('teams')}>Teams</a></th><th key="email"><a href={'#'} style={headerStyle} onClick={() => this.handleHeaderClick('email')}>Email</a></th><th key="telephone"><a href={'#'} style={headerStyle} onClick={() => this.handleHeaderClick('telephone')}>Telephone</a></th><th key="workingh"><a href={'#'} style={headerStyle} onClick={() => this.handleHeaderClick('workingHours')}>Working hours</a></th><th key="employedSince"><a href={'#'} style={headerStyle} onClick={() => this.handleHeaderClick('hiringDate')}>Employed since</a></th></Fragment>
  }

  renderDataWith(myData, type) {
    return Object.keys(myData).map((key) => {
      const employee = myData[key]
      const gravatarId = md5.hex_md5(employee['email'])
      const l = '/employee_details/' + employee['id']
      const le = '/edit_employee/' + employee['id']
      if (type === 'admin') {
        return <tr key={key}><td><ImageEmployee gravatar={gravatarId} name={employee['name']}></ImageEmployee></td><td><a href={l} style={linkStyle}>{employee['name']}</a></td><td>{employee['teams']}</td><td>{employee['email']}</td><td>{employee['telephone']}</td><td>{employee['workingHours']}</td><td>{employee['hiringDate']}</td><td colSpan="2"><span><a href={le} style={linkStyle}>Update</a><a href="#" onClick={() => this.handleSubmit(employee['id'])} style={linkStyle}>Delete</a></span></td></tr>
      }
      return <tr key={key}><td><ImageEmployee gravatar={gravatarId} name={employee['name']}></ImageEmployee></td><td>{employee['name']}</td><td>{employee['teams']}</td><td>{employee['email']}</td><td>{employee['telephone']}</td><td>{employee['workingHours']}</td><td>{employee['hiringDate']}</td></tr>
    }
    )
  }

  renderData(type) {
    if (!this.props.headers.includes(this.state.columnSorting)) {
      this.setState({columnSorting: 'name', nameSorting: 'ASC'})
    }

    let myData = null
    const header = this.state.columnSorting
    const headerSorting = header + 'Sorting'
    if (this.state[headerSorting] === 'ASC') {
      myData = _.orderBy(Object.values(this.state.emp.employees), [ header ], [ 'asc' ])
    } else {
      myData = _.orderBy(Object.values(this.state.emp.employees), [ header ], [ 'desc' ])
    }

    return this.renderDataWith(myData, type)
  }

  render() {
    if (this.state.emp) {
      if (this.state.emp.req_admin === true) {
        return <div className="row justify-content-center align-items-center" style={divStyle}><a href="/employees" id="mylink" style={aStyle}></a><div style={{marginBottom: '20px', paddingRight: '0px'}} className="col-sm-12"><a href="#" className="btn btn-light" style={{float: 'right'}}><FontAwesomeIcon icon="search"></FontAwesomeIcon></a><input type="text" className="mysearche" name="mysearche" style={{float: 'right'}} onKeyUp={() => this.search(true)} /></div><table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeader('admin')}</tr>{this.renderData('admin')}</tbody></table></div>
      } else {
        return <div className="row justify-content-center align-items-center" style={divStyle}><a href="/employees" id="mylink" style={aStyle}></a><div style={{marginBottom: '20px', paddingRight: '0px'}} className="col-sm-12"><a href="#" className="btn btn-light" style={{float: 'right'}}><FontAwesomeIcon icon="search"></FontAwesomeIcon></a><input type="text" className="mysearche" name="mysearche" style={{float: 'right'}} onKeyUp={() => this.search(true)} /></div><table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeader('member')}</tr>{this.renderData('member')}</tbody></table></div>
      }
    }
    return <div className="row justify-content-center align-items-center" style={divStyle}>Loading</div>
  }

  handleHeaderClick(header) {
    if (!this.props.headers.includes(header)) {
      return
    }

    const headerSorting = header + 'Sorting'
    const currentState = Object.assign({}, this.state)
    currentState.columnSorting = header
    if (currentState[headerSorting] === 'ASC') {
      currentState[headerSorting] = 'DESC'
    } else {
      currentState[headerSorting] = 'ASC'
    }
    this.setState(currentState)
  }

  handleSubmit(idU) {
    let urlf = '/api/v1/users/'
    urlf = urlf + idU.toString()
    confirmAlert({
      title: 'Confirm',
      message: 'Are you sure to delete this employee?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            fetch(urlf, {
              method: 'DELETE',
              headers: {
                'Content-Type': 'application/json',
              },
            })
            .then(response => response.json())
            .then((data) => {
              if (data.type === 'success'){
                document.getElementById('mylink').click()
              } else {
                console.error('err' + data)
              }
            })
            .catch((err) => {
              console.error('Error while deleting employee! ' + err)
            })
          },
        },
        {
          label: 'No',
          onClick: () => {
            document.getElementById('react-confirm-alert').close
          },
        },
      ],
    })
  }
}

Table.propTypes = {
  employees: PropTypes.object,
  headers: PropTypes.array,
}

export default Table
